import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { JobAuditContainerComponent } from './job-audit-container/job-audit-container.component';
const log = new LoggingService();

export const JobAuditRoute: Ng2StateDeclaration = {
    // name: 'JobAudit.**'
    name: 'jobaudit',
    url: '/jobaudit',
    // , loadChildren: () => import('./job-audit.module').then(r => r.JobAuditModule)
    data: { requiresAuth: true },

    component: JobAuditContainerComponent
};
